import type { OrganizationManagerDashboardStatsDto } from './organization-manager-dashboard.types';

/** Stand-in payload until the dashboard stats API is designed. */
export const ORGANIZATION_MANAGER_DASHBOARD_STATS_MOCK: OrganizationManagerDashboardStatsDto =
  {
    siteCount: 28,
    chargerCount: 300,
    lastUpdatedAt: '2026-08-20T10:32:00.000Z',
    sessionSuccess: {
      ratePercent: 94,
      targetPercent: 95,
    },
    topDropOffCauses: {
      primaryRank: 2,
      secondaryRank: 3,
      primaryCause: 'Payment terminal errors',
      secondaryCause: 'Connector locking issues',
      causesTracked: 2,
      progressPercent: 60,
    },
    accountability: {
      activeBreaches: 2,
      penaltiesTotalEuros: 3400,
      slaComplianceRatePercent: 92.8,
      compliantSites: 26,
      totalSites: 28,
      sites: [
        {
          id: 'horizon-mall',
          siteName: 'Horizon Mall',
          status: 'breach',
          hoursLate: 14,
          penaltyEuros: 1800,
        },
        {
          id: 'east-paris-hotel',
          siteName: 'East Paris Hotel',
          status: 'warning',
          hoursLate: 8,
          penaltyEuros: 1600,
        },
        {
          id: 'other-sites',
          siteName: '26 other sites',
          status: 'compliant',
          hoursLate: null,
          penaltyEuros: null,
        },
      ],
    },
    repairHours: {
      targetHours: 4,
      peakHours: 14,
      currentHours: 9.4,
      quarters: [
        { quarter: 'Q4', hours: 12, highlighted: false },
        { quarter: 'Q1', hours: 10, highlighted: false },
        { quarter: 'Q2', hours: 14, highlighted: true },
        { quarter: 'Q3', hours: 9.4, highlighted: false },
      ],
    },
    portfolio: [
      {
        id: 'commune-e',
        location: 'Commune E',
        chargersRating: 3.2,
        chargersRatingMax: 5,
        ownershipIssue: 'Charger unavailable',
        contractStatus: 'ADVENIR - Lot 3',
        businessImpact: 'critical',
      },
      {
        id: 'commune-b',
        location: 'Commune B',
        chargersRating: 3.8,
        chargersRatingMax: 5,
        ownershipIssue: 'Payment failure',
        contractStatus: 'Régional – Lot 5',
        businessImpact: 'warning',
      },
      {
        id: 'commune-a',
        location: 'Commune A',
        chargersRating: 4.5,
        chargersRatingMax: 5,
        ownershipIssue: 'Coverage (minor)',
        contractStatus: 'État – Lot 1',
        businessImpact: 'good',
      },
    ],
  };
